/**
 * Swiper
 * It is a modern touch slider with hardware accelerated transitions and amazing native behavior.
 * @see https://swiperjs.com/swiper-api
 */

import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';

Swiper.use([Pagination, A11y]);

const carousel = new Swiper('.carousel', {
  slidesPerView: 1,
  spaceBetween: 24,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});
